import { render, staticRenderFns } from "./PageHRDocumentCreate.vue?vue&type=template&id=6c08a36a&"
import script from "./PageHRDocumentCreate.vue?vue&type=script&lang=js&"
export * from "./PageHRDocumentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports